module.exports = __webpack_public_path__ + "static/img/k6.ea55995.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qtape/k6.png
// module id = QXlz
// module chunks = 1